import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../../../shared/services/common.service';

@Component({
  selector: 'app-payee-details',
  templateUrl: './payee-details.component.html',
  styleUrls: ['./payee-details.component.scss', '../../../shared/styles/summary.scss']
})
export class PayeeDetailsComponent implements OnInit {

  @Input() payee: any;
  @Input() paymentType: any;
  public config: any[];
  constructor(private commonService: CommonService) {
   }

    ngOnInit() {
      this.commonService.fetchConfig().subscribe((response: any) => {
        this.config = this.commonService.getConfigForElementKey(response, 'Requester Form').elementConfigList;
      });
    }
  }
